import dayjs from 'dayjs';

/**
 * Returns number of years since birthDate,
 * e.g formatAge("1985-06-01T00:00:00Z") // 31 (in 2017)
 */
export function formatAge(birthDate) {
  return dayjs().diff(birthDate, 'year');
}
